"use client";

import { CapabilityPage } from "@/components/sections/page-composer";
import { apiDocsData } from "@/lib/data/developers-api-documentation";

export function ApiDocsPage() {
  return <CapabilityPage data={apiDocsData} />;
}
